$(".product_slider").slick({
  slidesToShow: 3,
  autoplay: false,
  dots: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        variableWidth: true,
        arrows: false,
        slidesToShow: 2
      },
    },
  ],
});

// document.addEventListener("DOMContentLoaded", function () {
  // Select all sets of tabs with the class "main_tab_row"
const tabSets = document.querySelectorAll(".main_tab_row");

tabSets.forEach(function (tabSet) {
  const customTab = tabSet.querySelector(".custom_tab");

  // ✅ Check if custom_tab exists
  if (!customTab) return;

  const tabTitlesWrapper = customTab.querySelector(".tab_titles");

  // ✅ Also check tab_titles exists
  if (!tabTitlesWrapper) return;

  // Create active bar only once
  let activeBar = tabTitlesWrapper.querySelector(".active_bar");
  if (!activeBar) {
    activeBar = document.createElement("div");
    activeBar.className = "active_bar";
    tabTitlesWrapper.appendChild(activeBar);
  }

  const tabTitles = tabSet.querySelectorAll(".tab_title");
  const tabContents = tabSet.querySelectorAll(".tab_content");

  function setActiveTab(index) {
    tabTitles.forEach(tab => tab.classList.remove("active"));
    tabTitles[index].classList.add("active");

    tabContents.forEach(content => content.classList.remove("show"));
    tabContents[index].classList.add("show");

    const activeTab = tabTitles[index];

    const tabWidth = activeTab.offsetWidth;
    const tabLeft =
      activeTab.getBoundingClientRect().left -
      tabTitlesWrapper.getBoundingClientRect().left;

    activeBar.style.width = tabWidth + "px";
    activeBar.style.left = tabLeft + "px";
  }

  tabTitles.forEach(function (title, index) {
    title.addEventListener("click", function (e) {
      e.preventDefault();
      setActiveTab(index);
      document.querySelectorAll('.btn_two').forEach(b=>b.href=tabTitles[index].dataset.href);

      setTimeout(() => {
        $(".product_slider").slick("refresh");
      }, 300);
    });
  });

  setActiveTab(0);
  document.querySelectorAll('.btn_two').forEach(b=>b.href=tabTitles[0].dataset.href);
});
// });

// initializeCustomTabSlick();

// $(window).resize(initializeCustomTabSlick);
